<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      border="inner"
      resizable
      auto-resize
      highlight-hover-row
      :height="800"
      :data="data"
      :columns="columns"
      row-id="userCode"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
    >
      <template #toolbar_form>
        <slot name="header"></slot>
      </template>

      <template #pager>
        <div style="height: 40px;"></div>
      </template>

      <template #opt="{ row }">
        <i
          class="el-icon-delete tool-btn text-danger"
          @click="$emit('remove', row)"
        />
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableColumns from './table-columns'
export default {
  props: { data: { type: Array, default: () => [] } },
  computed: {
    columns() {
      return TableColumns(this)
    },
  },
}
</script>

<style lang="scss" scoped></style>
